import { theme, Img as ImgComponent } from "@superhi/design";
import styled from "styled-components";

export const Img = styled(ImgComponent).attrs({
  aspectRatio: "1:1.4142",
  fit: "cover",
})`
  ${theme.elevation.ELEVATION_50}
`;
